import Vue from 'vue'
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie'

Vue.use(VueI18n);
Vue.use(VueCookie)

const messages = {
  ru: {
    message: {
      actions:{
        continue:"Продолжить",
        remove:"Удалить",
        restore:"Восстановить",
        cancel:"Отмена",
        download:"Скачать",
        upload:"Загрузить",
        export:"Выгрузить",
        corrected:"Исправлено",
        ok:"Да",
      },
      common:{
        emptyTable:"В таблице нет записей",
        search:"Поиск",
        searchPlaceholder:"Начните набор",
        searchClear:"Очистить",
        manager: "Менеджер",
        errorMessage: "Что-то пошло не так. Попробуйте обновить страницу и повторить действие."
      },
      login:{
        title:'Добро пожаловать!',
        login:"Логин",
        password:"Пароль",
        enterLogin:"Введите логин",
        enterPassword:"Введите пароль",
        signIn:"Войти",
        logout:"Выйти"
      },
      workers:{
        title:'Исполнители',
        titleArchive:'Архив исполнителей',
        description:'',
        importExcel:'Импорт исполнителей из EXCEL',
        importHand:'Новый',
        table:{
          active_today:"Занят",
          name:"Имя",
          phone:"Телефон",
          rating:" Рейтинг",
          age:"Возраст",
          passport:"Паспорт",
          address:"Адрес",
          skill:" Умение",
          ready:" Готовность",
          description:" Примечание",
          actions:"Действия",
          view:"Просмотр",
          edit:"Ред.",
          remove:"Удалить",
          add_in_task:"В заявку",
          price:"Ставка",
          start_date:"Дата начала",
          end_date:"Дата конца",
          start_time:"Время начала",
          end_time:"Время конца",
          dinner:"Обед",
          total_price_payment:"Осталось оплатить",
          total_price:"Итого",
          total_hours:"Часы",
          task_id:"Заявка",
          last_task_end_date:"Конец последней заявки",
          paid:"Оплачено",
          cart_number:"Карта",
          restoreButton:"Восстановить",
        },
        modal:{
          title:"Исполнитель",
          nameInput:"Имя",
          namePlaceholder:"Иванов Иван Иванович",
          phoneInput:"Телефон",
          phonePlaceholder:"9112223344",
          phoneError:"Исполнитель с таким Телефоном уже есть в системе",
          ageInput:"Возраст",
          agePlaceholder:"Например 20",
          ageError:"Возраст указан неверно минимум 14, максимум 100",
          addressInput:"Адрес",
          addressPlaceholder:"Район, метро, адрес",
          passport_typeInput:"Тип паспорта",
          passport_typePlaceholder:"Например РФ",
          passport_urlInput:"Паспорт",
          passport_urlPlaceholder:"Добавьте документ",
          cart_numberInput:"Номер карты",
          cart_numberPlaceholder:"4276 0022 2121 3211",
          skillInput:"Умения",
          skillPlaceholder:"Например: Шуруповерт",
          readyInput:"Готовность",
          readyPlaceholder:"Например: работает по выходным",
          descriptionInput:"Примечание",
          descriptionPlaceholder:"Введите нужную информацию которой нет в полях выше",
          removeTitle:"Удаление исполнителя",
          removeDesc:"Вы уверены, что хотите удалить исполнителя",
          restoreTitle:"Восстановление исполнителя",
          restoreDesc:"Вы уверены, что хотите восстановить исполнителя из архива",
          importTitle:"Импорт товаров",
          template:"Шаблон EXCEL",
          importDesc:"Скачать шаблон можно по ссылке",
        }
      },
      tasks:{
        title:'Заявки',
        description:'',
        importExcel:'Импорт заявок из EXCEL',
        importHand:'Новая',
        table:{
          name:"Заявка",
          customer:"Заказчик",
          start_address:"Нач. адрес",
          location_name:"Объект",
          end_address:" Кон. адрес",
          start_date:"Дата начала",
          end_date:"Дата окончания",
          payment_type:"Тип оплаты",
          payment_first:"Стоимость часа",
          payment_second:"Стоимость последующего часа",
          workers_count:"Кол-во исп.",
          total_hours:"Итого часов",
          total_price:"Итого с заказчика",
          total_worker_price:"Итого исполнителям",
          total_delta:"Дельта",
          additional_cost:"Доп. расходы",
          additional_income:" Доп. доходы",
          description:"Примечание",
          cargo_description:"Описание груза",
          status_name:"Статус",
          paid_workers:"Оплачено исп.",
          executor_name:"Исполнитель",
          paid:"Оплачено зак.",
          contact:"Контакт",
          declarated_cost:"Расходы",
          actions:"Действия",
          view:"Просмотр",
          edit:"Ред.",
          remove:"Удалить",
          read_only:"Ред.",
        },
        modal:{
          title:"Исполнитель",
          customer:"Заказчик",
          customerPlaceholder:"Выберите заказчика",
          start_address:"Адрес",
          start_addressPlaceholder:"Адрес",
          end_address:" Конечный адрес",
          end_addressPlaceholder:"Введите конечный адрес",
          start_date:"Дата начала",
          start_datePlaceholder:"Введите дату начала",
          start_time:"Время начала",
          end_date:"Дата окончания",
          end_datePlaceholder:"Введите дату окончания",
          end_time:"Время окончания",
          payment_type:"Тип оплаты",
          payment_typePlaceholder:"Введите тип оплаты",
          payment_first_count:"Часы",
          payment_first:"Стоимость",
          payment_firstPlaceholder:"Стоимость",
          payment_second_count:"Часы 2",
          payment_second:"Стоимость 2",
          payment_secondPlaceholder:"Стоимость 2",
          workers_count:"Количество исполнителей",
          workers_countPlaceholder:"Введите кол-во исполнителей",
          total_hours:"Итого часов",
          total_hoursPlaceholder:"Введите итого часов",
          total_price:"Итого с заказчика",
          total_pricePlaceholder:"Введите итого заказчикам",
          total_worker_price:" Итого исполнителям",
          total_worker_pricePlaceholder:"Введите итого исполнителям",
          total_delta:"Дельта",
          total_deltaPlaceholder:"Введите дельта",
          additional_cost:" Доп. расходы",
          additional_income:" Доп. доходы",
          additional_costPlaceholder:"Введите доп расходы",
          description:"Примечание",
          descriptionPlaceholder:"Введите примечание",
          cargo_description:"Описание груза",
          cargo_descriptionPlaceholder:"Введите описание груза",
          status_id:"Статус",
          status_idPlaceholder:"Введите статус",
          total_manager:"Менеджеру на руки",
          total_managerPlaceholder:"Менеджеру на руки",
          removeTitle:"Удаление заявку",
          removeDesc:"Вы уверены, что хотите удалить заявку",
          author:"Автор",
          executor:"Исполнитель заявки",
          paid:"Оплачено заказчиком",
          contact:"Контакт",
          contactPlaceholder:"Контактное лицо на объекте",
          declarated_cost:"Расходы",
          acceptWorkerTitle:"Подтвержление оплаты исполнителю",
          acceptWorkerDesc:"Отключить оплату будет невозможно. Применить для ",
        }
      },
      organizations:{
        title:'Организации',
        description:'',
        importHand:'Новая',
        table:{
          name:"Название",
          phone:"Телефон",
          address:"Адрес",
          description:" Примечание",
          actions:"Действия",
          view:"Просмотр",
          edit:"Ред.",
          remove:"Удалить",
          inn: "ИНН",
          kpp: "КПП",
          ogrn: "ОГРН",
          full_name: "Полное наименование",
        },
        modal:{
          title:"Организация",
          nameInput:"Сокращенное наименование",
          nameInputDescription:"Сокращенное наименование организации или ИП",
          fullNameInput:"Полное наименование",
          fullNameInputDescription:"Полное наименование организации или ИП",
          phoneInput:"Телефон",
          phonePlaceholder:"Без пробелов и +7 Например 9112223344",
          phoneError:"Организация с таким Телефоном уже есть в системе",
          addressInput:"Адрес",
          addressPlaceholder:"Район, метро, адрес",
          descriptionInput:"Примечание",
          descriptionPlaceholder:"Введите нужную информацию которой нет в полях выше",
          removeTitle:"Удаление организации",
          removeDesc:"Вы уверены, что хотите удалить организацию",
          inn: "ИНН",
          kpp: "КПП",
          ogrn: "ОГРН",
          full_name: "Полное наименование",
          bik: "БИК",
          bank: "Наименование банка и город (банк)",
          cor_account: "Кор. счёт (к/с)",
          checking_account: "Расчётный счёт (р/с)",
          director: "Генеральный директор или ИП",
          accountant: "Главный бухгалтер",
        }
      },
      customers:{
        title:'Заказчики',
        description:'',
        importHand:'Новый',
        table:{
          name:"Название",
          phone:"Телефон",
          address:"Адрес",
          description:" Примечание",
          urflag:"Тип",
          actions:"Действия",
          view:"Просмотр",
          edit:"Ред.",
          remove:"Удалить",
          inn: "ИНН",
          kpp: "КПП",
          ogrn: "ОГРН",
          full_name: "Полное наименование",
        },
        modal:{
          title:"Заказчик",
          nameInput:"Сокращенное наименование заказчика",
          nameInputDescription:"Сокращенное наименование организации, ИП или физлица",
          fullNameInput:"Полное наименование заказчика",
          fullNameInputDescription:"Полное наименование организации, ИП или физлица",
          phoneInput:"Телефон",
          phonePlaceholder:"Без пробелов и +7 Например 9112223344",
          phoneError:"Заказчик с таким Телефоном уже есть в системе",
          addressInput:"Адрес",
          addressPlaceholder:"Район, метро, адрес",
          descriptionInput:"Примечание",
          descriptionPlaceholder:"Введите нужную информацию которой нет в полях выше",
          urflagInput:"Тип",
          rateInput:"Ставка менеджеру %",
          saleInput:"Скидка за час руб.",
          removeTitle:"Удаление заказчика",
          removeDesc:"Вы уверены, что хотите удалить заказчика",
          inn: "ИНН",
          kpp: "КПП",
          ogrn: "ОГРН",
          full_name: "Полное наименование",
          bik: "БИК",
          bank: "Наименование банка и город (банк)",
          cor_account: "Кор. счёт (к/с)",
          checking_account: "Расчётный счёт (р/с)",
        }
      },
      payments:{
        title:'Выплаты исполнителям',
        description:'',
        find:'Найти',
        date:'Дата',
        startDate:'С',
        endDate:'По',
        paid:'Подтверждение действия',
        paidDesc:'Подтвердить изменение оплаты для',
        table:{
          name:"Имя/Название",
          phone:"Телефон",
          address:"Адрес",
          description:" Примечание",
          urflag:"Тип",
          actions:"Действия",
          view:"Просмотр",
          edit:"Ред.",
          remove:"Удалить",
        },
      },
      statistics:{
        title:'Статистика',
        description:'',
        find:'Показать',
        date:'Дата',
        startDate:'С',
        endDate:'По',
        readOnlyTrue:'Запретить редактирование',
        readOnlyFalse:'Разрешить редактирование',
        paidTrue:'Оплачено заказчиком',
        paidFalse:' Не оплачено заказчиком',
      },
      users:{
        title:'Персональные предложения',
        description:'Список персональных предложений для каждого покупателя',
        personal:{
          title:"Персональные предложения",
          description:'',
          conditionTitle:"Условие:",
          conditionDesc:"Количество покупок > 0 и Акция на товар > 0",
          customer:"Покупатель:",
          login:"Логин:",
          email:"Email:",
          table:{
            name:"Наименование",
            barcode:"Штрихкод",
            price:"Цена",
            sale:"Акция",
            count:"Количество покупок",
          },
        },
        table:{
          login:"Логин",
          name:"Имя",
          email:"Email",
          actions:"Действия",
        },
      },
      locations:{
        title:'Объекты',
        description:'',
        importExcel:'Импорт объектов из EXCEL',
        create:'Новый',
        table:{
          name:"Название",
          address:"Адрес",
          contact:"Контакт",
          customer_name:"Заказчик",
          contract:"Договор",
          description:" Примечание",
          actions:"Действия",
          view:"Просмотр",
          edit:"Ред.",
          remove:"Удалить"
        },
        modal:{
          title:"Объект",
          nameInput:"Название",
          addressInput:"Адрес",
          contactInput: "Контакт",
          customerInput: "Заказчик",
          contractInput: "Договор",
          descriptionInput:" Примечание",
          removeTitle:"Удаление объекта",
          removeDesc:"Вы уверены, что хотите удалить объект",
          restoreTitle:"Восстановление объекта",
          restoreDesc:"Вы уверены, что хотите восстановить объект из архива",
          importTitle:"Импорт объектов",
          template:"Шаблон EXCEL",
          importDesc:"Скачать шаблон можно по ссылке",
        }
      },
      register:{
        title:'Реестр',
        description:'',
        find:'Сформировать реестр',
        date:'Дата',
        startDate:'С',
        endDate:'По',
        task_id:'Заявка',
        start_date_format:'Дата',
        executor_name:'Менеджер',
        customer_name:'Компания',
        start_address:'Объект',
        total_hours:'Часы',
        total_worker_price:'Исполнителям',
        total_price:'Нам оплатили',
        total_sell_delta:'Дельта',
        total_delta:'Итого дельта',
        payment_type:'Оплата',
        total_manager:'Менеджеру',
        workers: {
          start_address:'Адрес',
          worker: "Исполнитель",
          start_time_format: "Начало",
          end_time_format: "Окончание",
          payment_first:"Ставка",
        }
      },
    }
  }
};

Vue.config.lang = VueCookie.get('locale') || 'ru';

const i18n = new VueI18n({
  locale:  Vue.config.lang, // set locale
  messages, // set locale messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/localization/index.js